/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useRouter } from 'next/router';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Menu, MenuItem } from '@mui/material';
import Button from '@atoms/Button';
import Link from '@atoms/Link';

import { ToolbarContainer } from './style';
import { i18n, useTranslation } from '../../../../../config/i18n';
import { ISO_LANGUAGES } from '../../../../../constants';

const FormToolbar = ({ languages, opportunitySlug }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const router = useRouter();

  const { t } = useTranslation('common');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguage = (lang) => () => {
    i18n.changeLanguage(lang);
    handleClose();
  };



  return (
    <ToolbarContainer>
      <Link href="view_opportunity" params={{ slug: opportunitySlug }}>
        <Button Button size="small" startIcon={<ArrowBackIcon />} variant="text">
          {t('opportunity_info')}
        </Button>
      </Link>
      <Button size="small" endIcon={<ArrowDropDownIcon />} variant="text" onClick={handleClick}>
        {ISO_LANGUAGES[i18n.language] ? ISO_LANGUAGES[i18n.language].nativeName : i18n.language}
      </Button>
      <Menu
        id="application-language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {languages.map((lang) => (
          <MenuItem key={lang} onClick={handleLanguage(lang)}>
            {ISO_LANGUAGES[lang] ? ISO_LANGUAGES[lang].nativeName : lang}
          </MenuItem>
        ))}
      </Menu>
    </ToolbarContainer>
  );
};

FormToolbar.propTypes = {
  languages: PropTypes.array,
  opportunitySlug: PropTypes.string.isRequired,

};

FormToolbar.defaultProps = {
  languages: [],
};

export default FormToolbar;
